export default "__VITE_ASSET__BqXFJFdU__"